import React, { useState, useEffect } from 'react';
import { View, StyleSheet, ScrollView } from 'react-native';
import { Color, CommonStyles, CommonProperties } from '../styles';
import { useSelector } from 'react-redux';
import { selectCheckedRebookPassengers } from '../store/selectors/mytrips.selector';
import BaseText from './BaseText';
import { useComponentTKey, i18nNS } from '../i18n';
import InputForm from './InputForm';
import PickerSelect from './PickerSelect';
import DateInput from './DateInput';
import MessageAlert from './MessageAlert';
import RowView from '../components/RowView';
import { useTranslation } from 'react-i18next';
import { getCountries } from '../utils/country.utils';
import useTextGender from '../utils/useTextGender';
import useMonths from '../utils/useTextMonths';
import AccordionListItem from './AccordianList';
import { Checkbox } from '../components/Checkbox';
import PassengerTypes from '../constants/PassengerTypes';
import getPassengersNotInfantType from '../utils/passenger.util';
import useTextTitles from '../utils/useTextTitles';

export default function RebookPassengerDetailsFormik({ formProps, travelCart }) {
  const passengers = useSelector(selectCheckedRebookPassengers);
  const { t } = useTranslation(i18nNS.checkout);
  const { tKey } = useComponentTKey('PassengerScreen');
  const [countryList, setCountryList] = useState([]);
  const [termsAgreed, setTermsAgreed] = useState(false);
  //   const travelCart = useSelector((state) => state.search && state.search.travelCart);
  console.log(passengersNotInfant);
  const [gender] = useTextGender();
  const [months] = useMonths();
  const passengersNotInfant = getPassengersNotInfantType(travelCart.Passengers, passengers);
  const [titles] = useTextTitles();

  useEffect(() => {
    (async () => {
      const res = await getCountries();
      setCountryList(res);
    })();
  }, []);

  return (
    <View>
      {Object.keys(formProps.errors).length > 0 && <MessageAlert message={t(tKey('Required'))} />}
      {passengers?.map((passenger, index) => (
        <>
          <AccordionListItem key={index} title={formProps?.values?.passengers[index]?.firstname}>
            <View style={CommonStyles.flex1} key={index}>
              {passenger?.length > 1 && (
                <View style={styles.sectionHeader}>
                  <BaseText style={styles.sectionHeaderText}>Passenger {index + 1}</BaseText>
                </View>
              )}

              {passenger.PassengerType === 'INF' || passenger.PassengerType === 'INS' ? (
                <PickerSelect
                  errorMessage={
                    formProps?.errors?.passengers &&
                    formProps?.errors?.passengers[index]?.associateTravelerRefNumber
                  }
                  onValueChange={formProps.handleChange(
                    `passengers[${index}].associateTravelerRefNumber`
                  )}
                  items={passengersNotInfant}
                  value={formProps?.values?.passengers[index]?.associateTravelerRefNumber}
                />
              ) : (
                <></>
              )}

              <InputForm
                errorMessage={
                  formProps.errors.passengers && formProps.errors.passengers[index]?.firstname
                }
                onBlur={formProps.handleBlur(`passengers[${index}].firstname`)}
                value={formProps?.values?.passengers[index]?.firstname}
                placeholder={t(tKey('FirstName'))}
                onChangeText={formProps.handleChange(`passengers[${index}].firstname`)}
              />
              <InputForm
                errorMessage={
                  formProps?.errors?.passengers && formProps?.errors?.passengers[index]?.middlename
                }
                onBlur={formProps.handleBlur(`passengers[${index}].middlename`)}
                value={formProps?.values?.passengers[index]?.middlename}
                placeholder={t(tKey('MiddleName'))}
                onChangeText={formProps.handleChange(`passengers[${index}].middlename`)}
              />
              <InputForm
                errorMessage={
                  formProps?.errors?.passengers && formProps?.errors?.passengers[index]?.lastname
                }
                onBlur={formProps.handleBlur(`passengers[${index}].lastname`)}
                value={formProps?.values?.passengers[index]?.lastname}
                placeholder={t(tKey('LastName'))}
                onChangeText={formProps.handleChange(`passengers[${index}].lastname`)}
              />
              <InputForm
                errorMessage={
                  formProps?.errors?.passengers && formProps?.errors?.passengers[index]?.suffix
                }
                onBlur={formProps.handleBlur(`passengers[${index}].suffix`)}
                value={formProps?.values?.passengers[index]?.suffix}
                placeholder={t(tKey('Suffix'))}
                onChangeText={formProps.handleChange(`passengers[${index}].suffix`)}
              />
              <PickerSelect
                onValueChange={formProps.handleChange(`passengers[${index}].title`)}
                items={titles}
                value={formProps?.values?.passengers[index]?.title}
              />
              <DateInput
                errorMessage={
                  formProps?.errors?.passengers && formProps?.errors?.passengers[index]?.birthdate
                }
                date={formProps?.values?.passengers[index]?.birthdate}
                isEditModeEnabled={true}
                onDateChange={(value) =>
                  formProps.setFieldValue(`passengers[${index}].birthdate`, value)
                }
                label={t(tKey('DateOfBirth'))}
                months={months}
                labelMonth={t(tKey('Month'))}
              />
              <PickerSelect
                errorMessage={
                  formProps?.errors?.passengers && formProps?.errors?.passengers[index]?.gender
                }
                onValueChange={formProps.handleChange(`passengers[${index}].gender`)}
                items={gender}
                value={formProps?.values?.passengers[index]?.gender}
                label={t(tKey('SelectGender'))}
              />
              <InputForm
                errorMessage={
                  formProps?.errors?.passengers && formProps?.errors?.passengers[index]?.email
                }
                onBlur={formProps.handleBlur(`passengers[${index}].email`)}
                value={formProps?.values?.passengers[index]?.email}
                label={t(tKey('EmailAdress'))}
                onChangeText={formProps.handleChange(`passengers[${index}].email`)}
              />

              <RowView>
                <PickerSelect
                  onValueChange={formProps.handleChange(`passengers[${index}].phoneCountryCode`)}
                  items={countryList}
                  value={formProps?.values?.passengers[index]?.phoneCountryCode}
                  label={'Country'}
                  styleContainer={CommonStyles.flex1}
                />
                <InputForm
                  errorMessage={
                    formProps?.errors?.passengers && formProps?.errors?.passengers[index]?.phone
                  }
                  onBlur={formProps.handleBlur(`passengers[${index}].phone`)}
                  keyboardType="phone-pad"
                  value={formProps?.values?.passengers[index]?.phone}
                  label={t(tKey('Phone'))}
                  styleContainer={styles.inputSpacer}
                  onChangeText={formProps.handleChange(`passengers[${index}].phone`)}
                />
              </RowView>

              <RowView>
                <InputForm
                  errorMessage={
                    formProps?.errors?.passengers &&
                    formProps?.errors?.passengers[index]?.redressNumber
                  }
                  onBlur={formProps.handleBlur(`passengers[${index}].redressNumber`)}
                  value={formProps?.values?.passengers[index]?.redressNumber}
                  placeholder={t(tKey('RedressNumber'))}
                  label={t(tKey('RedressNumber'))}
                  styleContainer={CommonStyles.flex1}
                  onChangeText={formProps.handleChange(`passengers[${index}].redressNumber`)}
                />
                <InputForm
                  errorMessage={
                    formProps?.errors?.passengers &&
                    formProps?.errors?.passengers[index]?.knownTravellerNumber
                  }
                  onBlur={formProps.handleBlur(`passengers[${index}].knownTravellerNumber`)}
                  value={formProps?.values?.passengers[index]?.knownTravellerNumber}
                  placeholder={t(tKey('KnownTravellerNumber'))}
                  label={t(tKey('KnownTravellerNumber'))}
                  styleContainer={styles.inputSpacer}
                  onChangeText={formProps.handleChange(`passengers[${index}].knownTravellerNumber`)}
                />
              </RowView>
              <PickerSelect
                onValueChange={formProps.handleChange(
                  `passengers[${index}].knownTravellerNumberCountryCode`
                )}
                items={countryList}
                value={formProps?.values?.passengers[index]?.knownTravellerNumberCountryCode}
                label={t(tKey('ApplicableCountry'))}
              />
              {travelCart?.IsAir &&
                formProps?.values?.loyalty?.airLoyalty
                  ?.filter((program) => program.IsVisible)
                  ?.map((program, index) => {
                    return (
                      <View key={index.toString()}>
                        <InputForm
                          onBlur={formProps.handleBlur(`loyalty.airLoyalty[${index}].ProgramNo`)}
                          value={program.ProgramNo}
                          placeholder={program.PlaceHolder}
                          label={t(tKey('AirProgram'))}
                          onChangeText={formProps.handleChange(
                            `loyalty.airLoyalty[${index}].ProgramNo`
                          )}
                        />
                      </View>
                    );
                  })}

              {formProps?.values?.passengers[index]?.PassportDetails?.map((passport, i) => {
                return (
                  <View key={i}>
                    <RowView>
                      <InputForm
                        onBlur={formProps.handleBlur(
                          `passengers[${index}].passport.passportNumber`
                        )}
                        value={
                          formProps?.values?.passengers[index]?.PassportDetails[i]?.passportNumber
                        }
                        label={`${t(tKey('Passport'))} ${i + 1}`}
                        styleContainer={CommonStyles.flex1}
                        onChangeText={formProps.handleChange(
                          `passengers[${index}].PassportDetails[${i}].passportNumber`
                        )}
                      />
                      <PickerSelect
                        onValueChange={formProps.handleChange(
                          `passengers[${index}].PassportDetails[${i}].passportCountryCode`
                        )}
                        items={countryList}
                        style={styles.inputSpacer}
                        value={
                          formProps?.values?.passengers[index]?.PassportDetails[i]
                            ?.passportCountryCode
                        }
                        label={t(tKey('IssuingCountry'))}
                      />
                    </RowView>
                    <DateInput
                      errorMessage={
                        formProps?.errors?.passengers &&
                        formProps?.errors?.passengers[index] &&
                        formProps?.errors?.passengers[index]?.PassportDetails &&
                        formProps?.errors?.passengers[index]?.PassportDetails[i]?.passportDate
                      }
                      date={formProps?.values?.passengers[index]?.PassportDetails[i]?.passportDate}
                      isEditModeEnabled={true}
                      onDateChange={(value) =>
                        formProps.setFieldValue(
                          `passengers[${index}].PassportDetails[${i}].passportDate`,
                          value
                        )
                      }
                      label={t(tKey('DateOfExpiry'))}
                      months={months}
                      labelMonth={t(tKey('Month'))}
                    />
                  </View>
                );
              })}
            </View>
          </AccordionListItem>
        </>
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  sectionHeader: {
    backgroundColor: Color.primary,
    width: '100%',
    alignSelf: 'center',
    alignItems: 'center',
    ...CommonProperties.p2,
  },
  sectionHeaderText: {
    color: Color.accent,
  },
  inputSpacer: {
    flex: 1,
    ...CommonProperties.ml3,
  },
  termsSection: {
    flexDirection: 'row',
    ...CommonProperties.p2,
    justifyContent: 'space-between',
  },
  termsCheckboxContainer: {
    width: '10%',
    ...CommonProperties.mx2,
  },
  termsTextContainer: {
    width: '90%',
    textAlign: 'justify',
    ...CommonProperties.mx2,
  },
});
